import React from 'react';
import ReactDOM from 'react-dom/client';
import '@shopify/polaris/build/esm/styles.css';
import App from './pages/App';
import { PolarisProviders } from './providers/PolarisProviders';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <PolarisProviders>
      <App />
    </PolarisProviders>
  </React.StrictMode>,
);
